import { render, staticRenderFns } from "./ChangeMemberShip.vue?vue&type=template&id=5dd07f48&"
import script from "./ChangeMemberShip.vue?vue&type=script&lang=js&"
export * from "./ChangeMemberShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports